import $http from "@/services/axios";

export default function setup() {
  $http.interceptors.request.use(function(config) {
    return config;
  });
}
